import { useQuery } from '@tanstack/react-query';

import {
  useRequest,
  queryClient,
  type QueryFunction,
  type ReqsReviewConfig,
  type ValueTypeToAvailableUnits,
  type ResolutionConfig,
} from '@frontend/api';

type GetReqsReviewConfigResponse = {
  filterConfigs: ReqsReviewConfig;
  valueTypeToAvailableUnits: ValueTypeToAvailableUnits;
  resolutionConfig: ResolutionConfig;
};

const useReqsReviewConfig = ['reqsReviewConfig'] as const;
export const getUseReqsReviewConfigKey = () => useReqsReviewConfig;

export const useGetReqsReviewConfig: QueryFunction<
  GetReqsReviewConfigResponse,
  [],
  ReturnType<typeof getUseReqsReviewConfigKey>
> = ({ queryOptions, requestOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getUseReqsReviewConfigKey(),
    queryFn: ({ signal }) => {
      return request<GetReqsReviewConfigResponse>(
        '/rules/reqs_review_config/',
        {
          init: {
            signal,
          },
        },
      );
    },
  });
};

export const invalidateReqsReviewConfigQuery = () => {
  queryClient.invalidateQueries({ queryKey: getUseReqsReviewConfigKey() });
};
